define([
    'common/ui/view/svg/index',
    'common/ui/view/svg/icon',
    'common/ui/view/svg/text/label',
    'common/ui/view/svg/center-line-factory',
    'common/ui/view/svg/normal-line-factory',
    'common/ui/view/svg/util',
    'common/ui/view/svg/mark/index',
    'd3',
    'victor'
], function(
    SVGView,
    IconView,
    TextlabelView,
    CenterLineFactory,
    NormalLineFactory,
    SVGUtil,
    Mark,
    d3,
    Victor
    ) {
    var LinkView = SVGView.extend({
        lineType: 'solid',
        marks: [],
        label: '',
        bendAt: null,
        syncState: null,
        source: function() {
            return this.model.source;
        },
        target: function() {
            return this.model.target;
        },
        sourcePort: function() {
            return null;
        },
        targetPort: function() {
            return null;
        },
        findNodeView: function() {
            return null;
        },
        gripLineWidth: 64,
        labelSize: 30,
        labelOffset: {
            x: 0, y: 0
        },

        initialize: function(params) {
            LinkView.__super__.initialize.call(this, params);
            this.findNodeView = params.findNodeView ? params.findNodeView : this.findNodeView;
            this.listenTo(this.getSyncState(), 'change',
                this.renderSyncState);
            this.setSourceView();
            this.setTargetView();
            this.calcPos();
        },

        onRender: function() {
            LinkView.__super__.onRender.call(this);
            this.renderLine();
            this.renderMark();
            this.renderLabel();
            this.renderSyncState();
        },

        calcPos: function(){
            this.bendingPoint = this.getBendingPoint();
        },

        getBendAt: function() {
            if(_.isFunction(this.bendAt)) {
                return this.bendAt();
            } else {
                return this.bendAt;
            }
        },

        getSyncState: function() {
            if(_.isFunction(this.syncState)) {
                return this.syncState();
            } else {
                return this.syncState;
            }
        },

        getMarks: function() {
            if(_.isFunction(this.marks)) {
                return this.marks();
            } else {
                return this.marks;
            }
        },

        getLabel: function() {
            if(_.isFunction(this.label)) {
                return this.label();
            } else {
                return this.label;
            }
        },

        getLineType: function() {
            if(_.isFunction(this.lineType)) {
                return this.lineType();
            } else {
                return this.lineType;
            }
        },

        getSource: function() {
            if(_.isFunction(this.source)) {
                return this.source();
            } else {
                return this.source;
            }
        },

        getTarget: function() {
            if(_.isFunction(this.target)) {
                return this.target();
            } else {
                return this.target;
            }
        },

        getSourcePort: function() {
            if(_.isFunction(this.sourcePort)) {
                return this.sourcePort();
            } else {
                return this.sourcePort;
            }
        },

        getTargetPort: function() {
            if(_.isFunction(this.targetPort)) {
                return this.targetPort();
            } else {
                return this.targetPort;
            }
        },

        setSourceView: function() {
            if(this.isDestroyed()) {return;}
            var sourceView = this.findNodeView(this.getSource());
            this.listenTo(sourceView, 'move', this.onMove);
            this.listenTo(sourceView, 'move:end', this.onMoveEnd);
            this.listenToOnce(sourceView, 'destroy', function() {
                this.stopListening(sourceView, 'move', this.onMove);
                this.stopListening(sourceView, 'move:end', this.onMoveEnd);
                setTimeout(_.bind(this.setSourceView, this), 0);
            });
            this.sourceView = sourceView;
        },

        setTargetView: function() {
            if(this.isDestroyed()) {return;}
            var targetView = this.findNodeView(this.getTarget());
            this.listenTo(targetView, 'move', this.onMove);
            this.listenTo(targetView, 'move:end', this.onMoveEnd);
            this.listenToOnce(targetView, 'destroy', function() {
                this.stopListening(targetView, 'move', this.onMove);
                this.stopListening(targetView, 'move:end', this.onMoveEnd);
                setTimeout(_.bind(this.setTargetView, this), 0);
            });
            this.targetView = targetView;
        },

        getSourceView: function() {
            return this.sourceView;
        },

        getTargetView: function() {
            return this.targetView;
        },

        getSourceCenterPoint: function() {
            return this.getSourceView().getCenterPoint();
        },

        getTargetCenterPoint: function() {
            return this.getTargetView().getCenterPoint();
        },

        getSourceBorderPoint: function(angle, offset) {
            return this.getSourceView().getBorderPoint(angle, offset);
        },

        getTargetBorderPoint: function(angle, offset) {
            return this.getTargetView().getBorderPoint(angle, offset);
        },

        onBend: function(bendAt) {
            this.trigger('bend', bendAt);
        },

        onMove: function() {
            this.calcPos();
            this.render();
        },

        onMoveEnd: function() {
        },

        renderLabel: function() {
            this.removeLabel();
            this.labelView = new TextlabelView({
                offset: this.getOption('labelOffset'),
                size: this.getOption('labelSize')
            });
            this.$el.append(this.labelView.render().el);
            this.labelView.$el
                .attr('transform', SVGUtil.transform(this.bendingPoint.toObject()));
            this.labelView.text(this.getLabel());
            this.$el.classed('link-label', true);
        },

        removeLabel: function() {
            if(this.labelView) {
                this.labelView.remove();
            }
        },

        renderLine: function() {
            this.removeLine();

            var sourcePort = this.getSourcePort();
            var sourceView = sourcePort ? this.getSourceView().getPortView(sourcePort) : this.getSourceView();
            var targetPort = this.getTargetPort();
            var targetView = targetPort ? this.getTargetView().getPortView(targetPort) : this.getTargetView();
            var factory = sourcePort ? NormalLineFactory : CenterLineFactory;
            this.line = factory.build({
                sourceView: sourceView,
                targetView: targetView,
                bendingPoint: this.bendingPoint,
                offset: this.getOption('lineBorderOffset')
            });

            this.lineGripView = this.$el.append('path')
                .attr('d', this.line.getSVGPath())
                .classed('link-line', true)
                .style('stroke-width', this.getOption('gripLineWidth'))
                .attr('pointer-events', 'stroke')
                .style('visibility', 'hidden');
            this.lineView = this.$el.append('path')
                .attr('d', this.line.getSVGPath())
                .classed('link-line', true)
                .attr('pointer-events', 'stroke');

            if(this.getLineType()) {
                this.lineView.classed(this.getLineType(), true);
            }
        },

        removeLine: function() {
            if(this.lineView) {
                this.lineView.remove();
                this.lineGripView.remove();
            }
        },

        renderMark: function() {
            this.removeMark();
            this.markViews = [];
            _.each(this.getMarks(), _.bind(function(m) {
                var markView = new Mark(m);
                var position = m.position;
                var angleOffset = m.angleOffset;
                var pos = this.line.getDividingPoint(position);
                pos.rotate = - pos.angle + 90 + angleOffset;

                this.$el.append(markView.render().el);
                markView.$el
                    .attr('transform', SVGUtil.transform(pos))
                    .classed('link-mark', true);
                this.markViews.push(markView);
            }, this));
        },

        removeMark: function() {
            if(this.markViews) {
                _.each(this.markViews, function(m){m.remove()});
            }
        },

        renderBender: function() {
           this.removeBender();
           this.benderView = this.$el.append('circle')
               .classed('link-bender', true)
               .attr('r', 32)
               .attr('transform', SVGUtil.transform(
                   this.bendingPoint.toObject()));
           var self = this;
           var drag = d3.drag()
               .on('drag', function(){
                   self.bendingPoint.add(Victor(d3.event.dx, d3.event.dy));
                   self.render();
               })
               .on('end', function() {
                   var targetCenterPoint = self.getTargetCenterPoint();
                   var sourceCenterPoint = self.getSourceCenterPoint();
                   var offset = 64;

                   var source2target = targetCenterPoint.clone()
                       .subtract(sourceCenterPoint);
                   var startingPoint = self.getSourceBorderPoint(source2target, offset);
                   var endingPoint = self.getTargetBorderPoint(source2target.invert(), offset);

                   // source から見た bender
                   var bender = self.bendingPoint.clone()
                       .subtract(startingPoint);
                   var direction = endingPoint.clone()
                       .subtract(startingPoint);
                   var r = bender.dot(direction.clone().norm()) /
                       direction.length();
                   var d = bender.dot(
                       direction.clone().norm().rotateDeg(90));
                   self.onBend({r: r, d: d});
                   self.onMove();
               });
           this.benderView.call(drag);
        },

        removeBender: function() {
            if(this.benderView) {
                this.benderView.remove();
            }
        },

        renderSyncState: function() {
            var state = this.getSyncState();
            if(!state) {
                return;
            }
            var faclass = null;
            if(state.isUnsync()){
                faclass = 'fa fa-save';
            } else if (state.isSyncing()) {
                faclass = 'fa fa-refresh';
            } else if (state.isConflict()) {
                faclass = 'fa fa-exclamation text-danger';
            }

            this.removeSyncState();

            if(faclass) {
                var pos = this.line.getDividingPoint(0.4);
                var syncState = this.$el.append('g')
                    .classed('link-sync', true);
                syncState.append('circle')
                    .attr('r', 32)
                    .attr('cx', 0)
                    .attr('cy', 0);
                var icon = new IconView({
                    class: faclass,
                    offset: {x: 0, y: 0},
                    size: 40
                });
                syncState.append(icon.render().el);
                syncState.attr('transform', SVGUtil.transform(pos));

                if (state.isSyncing()) {
                    var rotate = function(angle) {
                        var angle = angle + 120;
                        icon.$el.transition()
                            .duration(1000)
                            .ease(d3.easeLinear)
                            .attr('transform', `rotate(${angle})`)
                            .on('end', function(){rotate(angle)});
                    };
                    rotate(0);
                }
            }
        },

        removeSyncState: function() {
            this.$el.selectAll('.link-sync').remove();
        },

        /**
         * 両端の Node の中心を結んだ直線が、それぞれの Node と交わった点を基準とし、
         * その内分点と、そこからの距離で bending Point を決定する。
         * それぞれの Node の中心点を基準にしないのは、Node 同士が近い場合に、
         * 内分点がどちらかの Node の内部に存在するという状況を防ぐため。
         *
         * @returns {Victor}
         */
        getBendingPoint: function() {
            var bendAt = this.getBendAt();
            if(!bendAt) {
                bendAt = {
                    r: 0.5,
                    d: 0
                }
            }
            var sourceCenterPoint = this.getSourceCenterPoint();
            var targetCenterPoint = this.getTargetCenterPoint();
            var offset = 64;

            var source2target = targetCenterPoint.clone()
                    .subtract(sourceCenterPoint);
            var startingPoint = this.getSourceBorderPoint(source2target, offset);
            var endingPoint = this.getTargetBorderPoint(source2target.invert(), offset);

            // 制御点から Node を結ぶ直線への垂線の足のベクトル
            var foot = startingPoint.clone().mix(endingPoint, bendAt.r);
            var norm = endingPoint.clone().subtract(startingPoint).norm().rotateDeg(90);
            return foot.add(norm.multiply(Victor(bendAt.d, bendAt.d)));
        }
    });

    return LinkView;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/link.js